export function drawConnectors(ctx, landmarks, connections, style) {
  const canvas = ctx.canvas;
  for (const connection of connections) {
    const from = landmarks[connection[0]];
    const to = landmarks[connection[1]];
    if (from && to) {
      ctx.beginPath();
      ctx.moveTo(from.x * canvas.width, from.y * canvas.height);
      ctx.lineTo(to.x * canvas.width, to.y * canvas.height);
      ctx.strokeStyle = style.color;
      ctx.lineWidth = style.lineWidth;
      ctx.stroke();
    }
  }
}

export function drawLandmarks(ctx, landmarks, style) {
  const canvas = ctx.canvas;
  for (const landmark of landmarks) {
    ctx.beginPath();
    ctx.arc(
      landmark.x * canvas.width,
      landmark.y * canvas.height,
      style.lineWidth * 2,
      0,
      2 * Math.PI
    );
    ctx.fillStyle = style.color;
    ctx.fill();
  }
}